import { Briefcase, Handshake, MapPinned, TrendingUp } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "./motion";
import { ProviderForm } from "./ProviderForm";

const PERKS = [
  { icon: Briefcase, title: "Established commercial accounts", text: "Work in buildings run by recognizable businesses across the region." },
  { icon: Handshake, title: "Clear scopes, clear expectations", text: "You know what's expected at every site before you start." },
  { icon: MapPinned, title: "Work close to home", text: "Sites throughout Central PA and the neighboring states." },
  { icon: TrendingUp, title: "Grow with a 30-year company", text: "Reliable partners get more sites over time." },
];

export const Partners = () => (
  <section id="partners" data-testid="partners-section" className="relative overflow-hidden border-t border-white/10 bg-[#121212] py-24 lg:py-36">
    <div className="pointer-events-none absolute -right-40 top-20 h-[520px] w-[520px] rounded-full bg-white/5 blur-[120px]" />
    <div className="relative mx-auto grid max-w-[1440px] gap-16 px-5 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Eyebrow index="06">The CMS Partner Network</Eyebrow>
          <MaskLines className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-[-0.03em] text-white sm:text-5xl lg:text-6xl" lines={["Good crews", "deserve", <span className="text-brand-400">good work.</span>]} />
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-300 md:text-lg">
              We're always looking for dependable cleaners, floor care techs, maintenance pros and subcontracting crews. If you take pride in the finish, we'd like to hear from you.
            </p>
          </Reveal>
          <div className="mt-10 overflow-hidden rounded-[22px] border border-white/10">
            <div className="cut-corner relative aspect-[16/10]">
              <img src="/img/sterile.jpg" alt="Cleaning professional mopping a bright facility corridor" className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#0A0A0A]/70 to-transparent" />
            </div>
          </div>
          <div className="mt-8 grid gap-6 sm:grid-cols-2">
            {PERKS.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.06} data-testid={`partner-perk-${i}`}>
                <p.icon className="h-6 w-6 text-brand-400" strokeWidth={1.75} />
                <h3 className="mt-3 font-display text-lg font-bold text-white">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-zinc-300">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
      <div className="lg:col-span-7">
        <ProviderForm />
      </div>
    </div>
  </section>
);
